import React from 'react';
import { ReactComponent as PdfIcon } from "../../static/images/pdf.svg";
import styled from 'styled-components';
import { TextBlock } from '../text';
import { FontFamilyMedium } from '../fonts';

const Container = styled.a`
    display: flex;
    align-items: center;
    padding: 15px 0;
`;

const IconContainer = styled.div`
    width: 45px;
    height: 62px;
    flex-shrink: 0;
`;

const LabelText = styled(TextBlock)`
    ${FontFamilyMedium};
    font-weight: 500;
    margin-left: 20px;
`;

export const AccordionChildFileDownload = ({ text = "Scarica documento", href="" }) => {
    return (
        <Container href={href} target="_blank" rel="noopener noreferrer">
            <IconContainer>
                <PdfIcon />
            </IconContainer>
            <LabelText>{text}</LabelText>
        </Container>
    )
}